import React from 'react';
import { User } from '../../models';

export function adjustWhitespaces(
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) {
  e.target.value = e.target.value.replace(/\s+/g, ' ');
  e.target.value = e.target.value.replace(/^\s/g, '');
}

export function removeTrailingWhitespaces(value: string) {
  return value.replace(/\s$/g, '');
}

export async function preprocessTwoFactorData(user: User) {
  if (!user.twoFactorDetails) {
    return user;
  }

  const t2f = { ...user.twoFactorDetails };

  if (t2f?.email && !t2f.email?.value) {
    t2f.email = null as any;
  }

  if (t2f?.phoneNumber && !t2f.phoneNumber?.number) {
    t2f.phoneNumber = null as any;
  }

  return {
    ...user,
    twoFactorDetails: t2f,
  };
}
